import { createSlice } from '@reduxjs/toolkit';

const teamSlice = createSlice({
  name: 'team',
  initialState: {
    teams: [],
    dataValid: true
  },
  reducers: {
    setTeams(state, action) {
        if (!action || !action.payload || !action.payload.teams) {
          state.teams = [];
        } else {
          state.teams = action.payload.teams.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) );
        }      
    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const teamActions = teamSlice.actions;

export default teamSlice;